/* eslint-disable no-unused-vars */
import React from "react";
import { Row, Col, Card, Button } from "antd";
import { useHistory } from "react-router-dom";
import Footer from "../../components/section/Footer";

const Page = () => {
  const history = useHistory();
  return (
    <section
      style={{
        overflowX: "hidden",
      }}
    >
      <Row
        align="middle"
        style={{
          padding: "2vh 3vw",
        }}
        id="mainPage"
      >
        <Col span={24} style={{ padding: "0 0 3vh 0" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              lineHeight: "normal",
            }}
          >
            <img
              src={`${process.env.PUBLIC_URL}/assets/Logo.png`}
              alt="logo"
              style={{
                height: 60,
              }}
            />
            <div
              className="text-default"
              style={{
                marginLeft: 16,
              }}
            >
              <div className="text-bold">KEMENTERIAN AGAMA</div>
              <div>REPUBLIK INDONESIA</div>
            </div>
          </div>
        </Col>
        <Col
          xl={12}
          xs={24}
          style={{
            padding: "0 8%",
          }}
        >
          <div
            className="text-bold"
            style={{ fontSize: "64px", color: "#389BF6" }}
          >
            SIPENDA
          </div>
          <div style={{ fontSize: "36px", color: "#389BF6", padding: "3vh 0" }}>
            SISTEM INFORMASI
            <br />
            PENDIDIKAN AGAMA DAN
            <br />
            KEAGAMAAN
          </div>
          <div style={{ fontSize: "24px" }}>
            Badan Litbang dan Diklat Kementerian Agama
          </div>
          <div style={{ fontSize: "24px" }}>Republik Indonesia</div>
        </Col>
        <Col
          xs={24}
          xl={12}
          style={{
            textAlign: "center",
          }}
        >
          <img
            src={`${process.env.PUBLIC_URL}/assets/kemenag-main.svg`}
            alt="Sipenda"
          />
        </Col>
        <Col span={24} style={{ padding: "5vh 0 10vh 0" }}>
          <div>
            <Card
              style={{
                fontSize: "24px",
                backgroundColor: "#389BF6",
                color: "#fff",
                textAlign: "center",
                borderRadius: "36px",
                padding: "1vh 2vw",
              }}
            >
              SIPENDA adalah sistem informasi yang digunakan untuk menampilkan
              visualisasi data-data analitik berupa indeks karakter siswa,
              pondok pesantren, pendidikan keagamaan dan pendidikan madrasah
              dalam rangka mengukur pertumbuhan pendidikan agama dan keagamaan.
            </Card>
          </div>
        </Col>
        <Col
          xs={24}
          xl={12}
          style={{
            textAlign: "center",
          }}
        >
          <img
            src={`${process.env.PUBLIC_URL}/assets/indeks-karakter-main.png`}
            alt="Sipenda"
          />
        </Col>
        <Col
          xl={12}
          xs={24}
          style={{
            padding: "0 8%",
          }}
        >
          <div
            style={{
              fontSize: "36px",
              color: "#389BF6",
              padding: "3vh 0 0 0",
              fontWeight: "500",
            }}
          >
            INDEKS KARAKTER
            <br />
            SISWA
          </div>
          <div style={{ fontSize: "24px", padding: "2vh 0" }}>
            Menampilkan data-data analitik untuk jenjang Pendidikan Menengah.
          </div>
          <div>
            <Button
              size="large"
              style={{
                backgroundColor: "#389BF6",
                color: "#fff",
                borderRadius: "8px",
                fontSize: "18px",
              }}
              onClick={() => {
                history.push("/indeks-karakter-siswa/1");
              }}
            >
              Lihat
            </Button>
          </div>
        </Col>
        <Col
          xl={12}
          xs={24}
          style={{
            padding: "20vh 8%",
          }}
        >
          <div
            style={{
              fontSize: "36px",
              color: "#389BF6",
              padding: "3vh 0 0 0",
              fontWeight: "500",
            }}
          >
            PONDOK PESANTREN
          </div>
          <div style={{ fontSize: "24px", padding: "2vh 0" }}>
            Menampilkan peta sebaran pada pondok pesantren di Indonesia.
          </div>
          <div>
            <Button
              size="large"
              style={{
                backgroundColor: "#389BF6",
                color: "#fff",
                borderRadius: "8px",
                fontSize: "18px",
              }}
              onClick={() => {
                history.push("/pondok-pesantren");
              }}
            >
              Lihat
            </Button>
          </div>
        </Col>
        <Col xs={24} xl={12} style={{ padding: "20vh 0", textAlign: "center" }}>
          <img
            src={`${process.env.PUBLIC_URL}/assets/pondok-pesantren-main.png`}
            alt="Sipenda"
          />
        </Col>
        <Col
          xs={24}
          xl={12}
          style={{ padding: "0 0 20vh 0", textAlign: "center" }}
        >
          <img
            src={`${process.env.PUBLIC_URL}/assets/pendidikan-keagamaan-main.png`}
            alt="Sipenda"
          />
        </Col>
        <Col
          xl={12}
          xs={24}
          style={{
            padding: "0 8% 20vh",
          }}
        >
          <div
            style={{
              fontSize: "36px",
              color: "#389BF6",
              padding: "3vh 0 0 0",
              fontWeight: "500",
            }}
          >
            PENDIDIKAN KEAGAMAAN
          </div>
          <div style={{ fontSize: "24px", padding: "2vh 0" }}>
            Menampilkan data-data analitik mengenai sebaran pendidikan
            keagamaan.
          </div>
          <div>
            <Button
              size="large"
              style={{
                backgroundColor: "#389BF6",
                color: "#fff",
                borderRadius: "8px",
                fontSize: "18px",
              }}
              onClick={() => {
                history.push("/pendidikan-keagamaan/1");
              }}
            >
              Lihat
            </Button>
          </div>
        </Col>
        <Col
          xl={12}
          xs={24}
          style={{
            padding: "0 8% 10vh",
          }}
        >
          <div
            style={{
              fontSize: "36px",
              color: "#389BF6",
              padding: "3vh 0 0 0",
              fontWeight: "500",
            }}
          >
            PENDIDIKAN MADRASAH
          </div>
          <div style={{ fontSize: "24px", padding: "2vh 0" }}>
            Menampilkan data-data pendidikan madrasah.
          </div>
          <div>
            <Button
              size="large"
              style={{
                backgroundColor: "#389BF6",
                color: "#fff",
                borderRadius: "8px",
                fontSize: "18px",
              }}
              onClick={() => {
                history.push("/pendidikan-madrasah");
              }}
            >
              Lihat
            </Button>
          </div>
        </Col>
        <Col
          xs={24}
          xl={12}
          style={{ padding: "0 0 10vh 0", textAlign: "center" }}
        >
          <img
            src={`${process.env.PUBLIC_URL}/assets/pendidikan-madrasah-main.png`}
            alt="Sipenda"
          />
        </Col>
      </Row>
      <img
        src={`${process.env.PUBLIC_URL}/assets/sipenda-bg-1.png`}
        alt="background"
        style={{
          position: "absolute",
          top: 0,
          right: 0,
          zIndex: -1,
        }}
      />
      <img
        src={`${process.env.PUBLIC_URL}/assets/sipenda-bg-2.png`}
        alt="background"
        style={{
          position: "absolute",
          left: 0,
          top: "90vh",
          zIndex: -1,
        }}
      />
      <img
        src={`${process.env.PUBLIC_URL}/assets/sipenda-bg-3.png`}
        alt="background"
        style={{
          position: "absolute",
          right: 0,
          top: "140vh",
          zIndex: -1,
        }}
      />
      <img
        src={`${process.env.PUBLIC_URL}/assets/sipenda-bg-4.png`}
        alt="background"
        style={{
          position: "absolute",
          left: 0,
          top: "210vh",
          zIndex: -1,
        }}
      />
      <img
        src={`${process.env.PUBLIC_URL}/assets/sipenda-bg-5.png`}
        alt="background"
        style={{
          position: "absolute",
          right: 0,
          top: "270vh",
          zIndex: -1,
        }}
      />
      <Footer />
    </section>
  );
};

export default Page;
